import {
    TablePage
  } from 'src/views/acihighway/d4Notices'
  import pathMap from 'src/paths/pathMap'
  
  class AciHighwayD4NoticeRoute {
    getConfigurations() {
      return [
        {
          exact: true,
          path: pathMap.ACI_HW_D4_NOTICE_LIST_VIEW,
          component: TablePage
        }
      ]
    }
  }
  
  export default AciHighwayD4NoticeRoute
  